
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/digitalcampaigndoubleoptin",
      function () {
        return require("private-next-pages/digitalcampaigndoubleoptin.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/digitalcampaigndoubleoptin"])
      });
    }
  